import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DateArrayToStringPipeModule } from '../pipes/date-array-to-string.pipe';
import { RadioModule } from '../shared/radio/radio.component';
import { SharedModule } from '../shared/shared.module';
import { AskATeacherFeedbackModalComponent } from './ask-a-teacher-feedback-modal/ask-a-teacher-feedback-modal.component';
import { MessageBubbleComponent } from './message-bubble/message-bubble.component';
import { TeacherFeedbackCollectionComponent } from './teacher-feedback-collection/teacher-feedback-collection.component';
import { TeacherFeedbackDetailComponent } from './teacher-feedback-detail/teacher-feedback-detail.component';
import { TeacherFeedbackModalComponent } from './teacher-feedback-modal/teacher-feedback-modal.component';
import { TeacherFeedbackRateComponent } from './teacher-feedback-rate/teacher-feedback-rate.component';
import { LegacyTeacherFeedbackService } from './teacher-feedback-service/legacy-teacher-feedback.service';
import { TeacherFeedbackSnippetComponent } from './teacher-feedback-snippet/teacher-feedback-snippet.component';
import { TeacherFeedbackSurveyModalComponent } from './teacher-feedback-survey-modal/teacher-feedback-survey-modal.component';
import { LiveclassSurveySelectorComponent } from './teacher-liveclass-feedback-modal/liveclass-survey/liveclass-survey-selector/liveclass-survey-selector.component';
import { LiveclassSurveyComponent } from './teacher-liveclass-feedback-modal/liveclass-survey/liveclass-survey.component';
import { TeacherLiveClassFeedbackModalComponent } from './teacher-liveclass-feedback-modal/teacher-liveclass-feedback-modal.component';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';

@NgModule({
  imports: [CommonModule, SharedModule, NgbModule.forRoot(), DateArrayToStringPipeModule, RadioModule, SafeUrlPipeModule],
  declarations: [
    MessageBubbleComponent,
    TeacherFeedbackCollectionComponent,
    TeacherFeedbackDetailComponent,
    TeacherFeedbackModalComponent,
    TeacherLiveClassFeedbackModalComponent,
    TeacherFeedbackRateComponent,
    TeacherFeedbackSnippetComponent,
    TeacherFeedbackSurveyModalComponent,
    AskATeacherFeedbackModalComponent,
    LiveclassSurveyComponent,
    LiveclassSurveySelectorComponent,
  ],
  providers: [LegacyTeacherFeedbackService],
  entryComponents: [
    TeacherFeedbackModalComponent,
    TeacherFeedbackSurveyModalComponent,
    TeacherLiveClassFeedbackModalComponent,
    AskATeacherFeedbackModalComponent,
  ],
  exports: [TeacherFeedbackCollectionComponent],
})
export class TeacherFeedbackModule {}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-feedback.module.ts